// extracted by mini-css-extract-plugin
export default {"container":"Home_container__9OvUR","flex-row":"Home_flex-row__R12qH"};